import { render, staticRenderFns } from "./medicion-prevalencia.vue?vue&type=template&id=1b21a9a4&scoped=true&"
import script from "./medicion-prevalencia.vue?vue&type=script&lang=js&"
export * from "./medicion-prevalencia.vue?vue&type=script&lang=js&"
import style0 from "./medicion-prevalencia.vue?vue&type=style&index=0&id=1b21a9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21a9a4",
  null
  
)

export default component.exports